import { configureStore } from "@reduxjs/toolkit";
import EmailSlice from "./Slices/EmailSlice";
import MobileSlice from "./Slices/MobileSlice";
import FaxSlice from "./Slices/FaxSlice";
import PhoneSlice from "./Slices/PhoneSlice";
import PostMailSlice from "./Slices/PostMailSlice";
import LangSettings from "./Slices/LangSettingsSlice";
import NameSlice from "./Slices/NameSlice";
import SMSSlice from "./Slices/SMSSlice";
import WhatsAppSlice from "./Slices/WhatsAppSlice";

export default configureStore({
  reducer: {
    langSettings: LangSettings,
    email: EmailSlice,
    postMail: PostMailSlice,
    phone: PhoneSlice,
    mobile: MobileSlice,
    fax: FaxSlice,
    names: NameSlice,
    sms: SMSSlice,
    whatsapp: WhatsAppSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});
